import React, { useContext } from 'react';
import { TagTable } from '@tag/tag-components-react-v2';
import { TagSearchbox, ISearchArgs } from '@tag/tag-components-react-v3';
import { darkModeContext } from '../darkModeContext';

type Props = {
  data: PropTableColumns[];
  hideAttributes?: boolean;
};
export type PropTableColumns = {
  property: string;
  attribute: string;
  description?: string;
  type?: string;
  defaultValue?: string;
};
export const ComponentProps: React.FC<Props> = ({ data, hideAttributes = false }) => {
  const [criteria, setCriteria] = React.useState('');
  const handleSearch = (e: CustomEvent<ISearchArgs>) => {
    setCriteria(e.detail.criteria);
  };
  const dmContext = useContext(darkModeContext);
  return (
    <div>
      <TagSearchbox
        placeholder="Search for prop name ..."
        value={criteria}
        delay={0}
        onSearch={handleSearch}
        colourScheme={dmContext.value ? 'dark' : 'light'}
      />
      <TagTable
        columns={[
          {
            name: 'property',
            caption: 'Property',
            sortable: true,
          },
          {
            name: 'attribute',
            caption: 'Attribute',
            sortable: true,
          },
          {
            name: 'description',
            caption: 'Description',
          },
          {
            name: 'type',
            caption: 'Type',
          },
          {
            name: 'defaultValue',
            caption: 'Default Value',
          },
        ].filter(c => {
          if (hideAttributes) {
            return hideAttributes && c.name !== 'attribute';
          } else {
            return true;
          }
        })}
        data={data.filter(
          row =>
            row.property.toLowerCase().indexOf(criteria.toLowerCase()) > -1 ||
            (row.description || '').toLowerCase().indexOf(criteria.toLowerCase()) > -1,
        )}
      />
    </div>
  );
};
